import * as actionTypes from './actionTypes';

export const setSelectedData = (selectedData) => ({
  type: actionTypes.SET_SELECTED_DATA,
  selectedData,
});

export const setActiveViewMode = (activeViewMode) => ({
  type: actionTypes.SET_VIEW_MODE,
  activeViewMode,
});
